import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=f8123d10&scoped=true&"
import script from "./back-to-top.vue?vue&type=script&lang=ts&"
export * from "./back-to-top.vue?vue&type=script&lang=ts&"
import style0 from "./back-to-top.vue?vue&type=style&index=0&id=f8123d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8123d10",
  null
  
)

export default component.exports